import '../../../componentsStyling/ContentStyling.css';
import EditInventory from '../EditInventory.js';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

const getColumnDef = ({ userRole, loadInventory, onDelClick, isSmallScreen, updateAsset }) => {
    const fullColumnDefs = [
        { field: 'tag', headerName: 'Tag', width: 100 },
        { field: 'item', headerName: 'Item', width: 200 },
        { field: 'model', headerName: 'Model', width: 180 },
        { field: "type", headerName: "Type", width: 180 },
        { field: 'typeDescription', headerName: 'Type Description', width: 220 },
        { field: 'assetCondition', headerName: 'Condition', width: 110 },
        { field: 'purchaseCost', headerName: 'Item Value', width: 150 },
        { field: 'purchaseDate', headerName: 'Purchase Date', width: 150 },
        { field: 'location', headerName: 'Location', width: 150 },
        {
            field: 'kitItems',
            headerName: 'Kit Items',
            width: 100,
            renderCell: (params) => {
                const items = Array.isArray(params.row.kitItems) ? params.row.kitItems : [];
                return items.length > 0 ? items.length : 'None';
            }
        },
        { field: 'checkedOut', headerName: 'Checked Out', width: 150 },
        {
            field: 'edit',
            headerName: '',
            sortable: false,
            filterable: false,
            renderCell: (row) => (
                <div onClick={(event) => event.stopPropagation()}>
                    {(userRole === 'ROLE_ADMIN' || userRole === 'ROLE_STAFF') && (
                        <EditInventory
                            data={row}
                            updateAsset={(asset, tag) =>
                                updateAsset(asset, tag).then((success) => {
                                    if (success) loadInventory(); else alert('Something went wrong!');
                                })
                            }
                        />
                    )}
                </div>
            ),
        },
        {
            field: 'delete',
            headerName: '',
            sortable: false,
            filterable: false,
            renderCell: (params) =>
                (userRole === 'ROLE_ADMIN' || userRole === 'ROLE_STAFF') && (
                    <IconButton onClick={(event) => onDelClick(event, params.row.tag)}>
                        <DeleteIcon color="error" />
                    </IconButton>
                ),
        },
    ];

    const smallColumnDefs = [
        { field: 'tag', headerName: 'Tag', width: 80 },
        { field: 'item', headerName: 'Item', width: 150 },
        { field: 'model', headerName: 'Model', width: 140 },
        { field: 'typeDescription', headerName: 'Type', width: 160 },
        {
            field: 'kitItems',
            headerName: 'Kit Items',
            width: 75,
            renderCell: (params) => {
                const items = Array.isArray(params.row.kitItems) ? params.row.kitItems : [];
                return items.length > 0 ? items.length : 'None';
            }
        },
        {
            field: 'edit',
            headerName: '',
            sortable: false,
            filterable: false,
            width: 80,
            renderCell: (row) => (
                <div onClick={(event) => event.stopPropagation()}>
                    {(userRole === 'ROLE_ADMIN' || userRole === 'ROLE_STAFF') && (
                        <EditInventory
                            data={row}
                            updateAsset={(asset, tag) =>
                                updateAsset(asset, tag).then((success) => {
                                    if (success) loadInventory(); else alert('Something went wrong!');
                                })
                            }
                        />
                    )}
                </div>
            ),
        },
        {
            field: 'delete',
            headerName: '',
            sortable: false,
            filterable: false,
            width: 80,
            renderCell: (params) =>
                (userRole === 'ROLE_ADMIN' || userRole === 'ROLE_STAFF') && (
                    <IconButton onClick={(event) => onDelClick(event, params.row.tag)}>
                        <DeleteIcon color="error" />
                    </IconButton>
                ),
        },
    ];

    return isSmallScreen ? smallColumnDefs : fullColumnDefs;
};

export default getColumnDef;